<template>
<ValidationObserver ref="observer">
  <form ref="edit_business_unit_form" @submit.prevent="handleSubmit(updateSpj)">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Client Master
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <label class="md-form-label">From Date*</label>
            <validation-provider rules="from" v-slot="{ errors }">
              <md-field class="md-invalid">
                <md-input type="date" v-model="edit_bulk_spj_from_date" required  />
                <validation-error :errors="apiValidationErrors.edit_bulk_spj_from_date" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
            </validation-provider>
          </div>
          <div class="md-layout-item md-small-size-100">
            <label class="md-form-label">To Date</label>
            <validation-provider rules="to" v-slot="{ errors }">
              <md-field class="md-invalid">
                <md-input type="date" v-model="edit_bulk_spj_to_date" required  />
                <validation-error :errors="apiValidationErrors.edit_bulk_spj_to_date" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <validation-provider rules="plan" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Payment Plan</label>
                <md-select v-model="edit_bulk_spj_payment_plan_id" required>
                    <md-option v-for="option in options_payment_list" :key="option.value" :value="option.id">
                      {{ option.payment_plan_name }}
                    </md-option>
                  </md-select>
                <validation-error :errors="apiValidationErrors.edit_bulk_spj_from_date" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <validation-provider rules="amount" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Amount</label>
                <md-input type="text" v-on:keypress="NumbersOnly" v-model="edit_bulk_spj_amount" required  />
                <validation-error :errors="apiValidationErrors.edit_bulk_spj_amount" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
            </validation-provider>
          </div>
        </div>
      </md-card-content> 
      

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

extend('plan', {
  ...required,
  message: 'Payment Plan Installment Field is required'
});
extend('from', {
  ...required,
  message: 'Form Date Field is required'
});
extend('to', {
  ...required,
  message: 'To Date Field is required'
});
extend('amount', {
  ...required,
  message: 'Amount Field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    
    

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    // props:{
    //   data_id:null
    // },
    
   data: () => ({
     edit_bulk_spj_from_date : null,
     edit_bulk_spj_to_date : null,
     edit_bulk_spj_payment_plan_id : null,
     options_payment_list : null,
     edit_bulk_spj_amount : null,
    }),

    created() {
      this.getPaymentPlanData();
    },


     methods: {
       // ambil data yang dibutuhkan
    async getPaymentPlanData() { 
        await this.$store.dispatch("fms_payment_plan/list",{filter:{payment_plan_type:1}})
        this.options_payment_list = await this.$store.getters["fms_payment_plan/list"]
        
      },

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

      formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateBulkSpj()
          }
        });
    },


    // fungsi edit
      async updateBulkSpj() {

        // if(this.$route.params.id == null || !this.$route.params.id) {
        //   await this.$store.dispatch("alerts/error", "error")
        //   return
        // }

        const data = {
          type: "fms_spj_black_plates",
          edit_bulk_spj_from_date : this.edit_bulk_spj_from_date,
          edit_bulk_spj_to_date : this.edit_bulk_spj_to_date,
          edit_bulk_spj_payment_plan_id : this.edit_bulk_spj_payment_plan_id,
          edit_bulk_spj_amount : this.edit_bulk_spj_amount,
        }

        try {
          //kirim data ke server
          await this.$store.dispatch("fms_spj/update_bulk", data)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "SPJ data changed successfully.")
          //kembali ke list
          this.$parent.$parent.modalCloseEditBulkSpj()
        } catch (e) {
          //panggil notifikasi error
          
          console.log(e)
          // await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          // this.setApiValidation(e.response.data.errors)
        }

      }



    // //fungsi yang ada di parent di panggil saat memilih row di table
    // onSelect (item) {
    //   this.$parent.$parent.$parent.$parent.modalCloseListDriver(item,this.item)
    //   },

      

     },

     
     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>